<template>
    <div class="t-standard-guide">
        <OHeader :view="view"/>
        <OMainFrame :view="view"/>
        <OFooter :view="view"/>
    </div>
</template>

<script>
import OHeader from '../../../organisms/o-header/o-header';
import OMainFrame from '../../../organisms/o-main-frame';
import OFooter from "@/components/organisms/o-footer/o-footer";

import { VIEWS } from "@/utils/constants/pages";

export default {
    name: "TStandardGuide",
    components: {
        OHeader,
        OFooter,
        OMainFrame
    },
    setup() {
        const view = VIEWS.GUIDE;

        return {
            view
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>